var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fs-14 secondary-text"},[_vm._v("\n  "+_vm._s(_vm.unitFormatLabel)+"\n  "),(_vm.format != null && _vm.volume != null)?_c('span',[_vm._v("\n    - "+_vm._s(_vm.getFormat)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }